import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

import { ImageHalf as ImageHalfDefault, TextHalf as TextHalfDefault } from './index.base';

export * from './index.base';

export const ImageHalf = styled(ImageHalfDefault)`
  ${Styles.desktop} {
    justify-content: flex-end;
  }
`;

export const TextHalf = styled(TextHalfDefault)`
  padding-block-start: ${primitive.$spacing9};

  ${Styles.desktop} {
    justify-content: flex-start;
    order: 1;
  }
`;
